import type { InvoiceStatusType } from 'api/swagger';
import { InvoiceStatus } from 'types/invoice-status';
import { ALL_INVOICE_STATUSES } from './constants';

export const STATUSES_EXCLUDING_LEGAL_ACTIONS: InvoiceStatusType[] = ALL_INVOICE_STATUSES.filter(
  (status) => status != InvoiceStatus.LegalActions,
);
